import React, { useEffect, useMemo, useRef } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import useLockBodyScroll from '../../hooks/useLockBodyScroll';
import buildImageUrl from '../../config/imageUrlHelper';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

function getSocialIcon(rrss) {
  if (!rrss) return null;
  const url = rrss.toLowerCase();
  if (url.includes('twitch')) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 shrink-0">
        <path d="M11.571 4.714h1.715v5.143H11.57zm4.715 0H18v5.143h-1.714zM6 0L1.714 4.286v15.428h5.143V24l4.286-4.286h3.428L22.286 12V0zm14.571 11.143l-3.428 3.428h-3.429l-3 3v-3H6.857V1.714h13.714z" />
      </svg>
    );
  }
  if (url.includes('tiktok')) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 shrink-0">
        <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
      </svg>
    );
  }
  if (url.includes('instagram')) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 shrink-0">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
    );
  }
  if (url.includes('twitter') || url.includes('x.com')) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 shrink-0">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.747l7.73-8.835L1.254 2.25H8.08l4.259 5.631zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    );
  }
  if (url.includes('youtube') || url.includes('youtu.be')) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 shrink-0">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    );
  }
  if (url.includes('kick.com')) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 shrink-0">
        <path d="M1.333 0h8v5.333H12V2.667h2.667V0h8v8H20v2.667h-2.667v2.666H20V16h2.667v8h-8v-2.667H12v-2.666H9.333V24h-8z" />
      </svg>
    );
  }
  if (url.includes('facebook') || url.includes('fb.com') || url.includes('fb.me')) {
    return (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 shrink-0">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
      </svg>
    );
  }
  return null;
}

function getSocialLabel(rrss) {
  if (!rrss) return '';
  const url = rrss.toLowerCase();
  if (url.includes('twitch')) return 'Twitch';
  if (url.includes('tiktok')) return 'TikTok';
  if (url.includes('instagram')) return 'Instagram';
  if (url.includes('twitter') || url.includes('x.com')) return 'X / Twitter';
  if (url.includes('youtube') || url.includes('youtu.be')) return 'YouTube';
  if (url.includes('kick.com')) return 'Kick';
  if (url.includes('facebook') || url.includes('fb.com') || url.includes('fb.me')) return 'Facebook';
  return 'Red Social';
}

const BAR_COLORS = [
  'rgba(255, 193, 7, 0.85)',    // oro
  'rgba(180, 180, 180, 0.85)',  // plata
  'rgba(176, 102, 50, 0.85)',   // bronce
];
const DEFAULT_BAR_COLOR = 'rgba(99, 179, 237, 0.75)';
const BORDER_COLORS = [
  'rgba(255, 160, 0, 1)',
  'rgba(140, 140, 140, 1)',
  'rgba(140, 78, 30, 1)',
];
const DEFAULT_BORDER = 'rgba(66, 153, 225, 1)';
const FIXED_Y_MAX = 12;
const FIXED_Y_STEP = 2;

function getSharedRankParticipants(list) {
  let previousAciertos = null;
  let previousComodines = null;
  let currentRank = 0;

  return list.map((participant, index) => {
    const aciertos = Number(participant.preguntas_acertadas) || 0;
    const comodines = Number(participant.comodines_restantes) || 0;

    if (aciertos !== previousAciertos || comodines !== previousComodines) {
      currentRank += 1;
      previousAciertos = aciertos;
      previousComodines = comodines;
    }

    return {
      participant,
      rank: currentRank,
      index,
    };
  });
}

export default function RankingModal({ participantes, onClose }) {
  useLockBodyScroll();
  const backdropRef = useRef(null);
  const avatarCacheRef = useRef({});
  const cardRefs = useRef({});
  const isMobileViewport = typeof window !== 'undefined' && window.matchMedia('(max-width: 640px)').matches;
  const chartHeight = isMobileViewport ? 182 : 226;
  const chartMinWidth = Math.max(isMobileViewport ? 520 : 620, participantes.length * (isMobileViewport ? 58 : 66));
  const rankedParticipants = useMemo(() => getSharedRankParticipants(participantes), [participantes]);

  const getParticipantKey = (p, idx) => String(p?.id ?? `${p?.nombre || 'participante'}-${idx}`);

  const scrollToParticipantCard = (index) => {
    const target = participantes[index];
    if (!target) {
      return;
    }

    const key = getParticipantKey(target, index);
    const cardEl = cardRefs.current[key];
    if (!cardEl) {
      return;
    }

    cardEl.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest',
    });
  };

  const getAvatarGeometry = (chart) => {
    const xScale = chart?.scales?.x;
    const chartArea = chart?.chartArea;
    if (!xScale || !chartArea) {
      return null;
    }

    const chartWidth = chartArea.right - chartArea.left;
    const avatarSize = chartWidth < 420 ? 18 : 24;
    const radius = avatarSize / 2;
    const yCenter = chartArea.bottom + (chartWidth < 420 ? 14 : 18);

    return { xScale, chartArea, chartWidth, avatarSize, radius, yCenter };
  };

  const getAvatarHitIndex = (chart, x, y) => {
    const geometry = getAvatarGeometry(chart);
    if (!geometry || !Array.isArray(participantes) || participantes.length === 0) {
      return -1;
    }

    const { xScale, radius, yCenter } = geometry;
    const hitRadiusSq = radius * radius;

    for (let index = 0; index < participantes.length; index += 1) {
      const xCenter = xScale.getPixelForTick(index);
      if (!Number.isFinite(xCenter)) {
        continue;
      }

      const dx = x - xCenter;
      const dy = y - yCenter;
      if ((dx * dx) + (dy * dy) <= hitRadiusSq) {
        return index;
      }
    }

    return -1;
  };

  const avatarTickPlugin = {
    id: 'avatarTickPlugin',
    afterDraw: (chart) => {
      const { ctx } = chart;
      const geometry = getAvatarGeometry(chart);

      if (!ctx || !geometry || !Array.isArray(participantes) || participantes.length === 0) {
        return;
      }

      const { xScale, chartWidth, avatarSize, radius, yCenter } = geometry;

      participantes.forEach((p, index) => {
        const xCenter = xScale.getPixelForTick(index);
        if (!Number.isFinite(xCenter)) {
          return;
        }

        const imageSrc = typeof p?.imagen === 'string' && p.imagen.trim() ? buildImageUrl(p.imagen.trim()) : '';
        let avatarState = imageSrc ? avatarCacheRef.current[imageSrc] : null;

        if (imageSrc && !avatarState) {
          const img = new Image();
          img.decoding = 'async';
          img.crossOrigin = 'anonymous';

          avatarState = { status: 'loading', img };
          avatarCacheRef.current[imageSrc] = avatarState;

          img.onload = () => {
            avatarState.status = 'loaded';
            if (chart?.ctx && !chart._destroyed) {
              chart.draw();
            }
          };

          img.onerror = () => {
            avatarState.status = 'error';
            if (chart?.ctx && !chart._destroyed) {
              chart.draw();
            }
          };

          img.src = imageSrc;
        }

        ctx.save();
        ctx.beginPath();
        ctx.arc(xCenter, yCenter, radius, 0, Math.PI * 2);
        ctx.closePath();
        ctx.fillStyle = document.documentElement.classList.contains('dark') ? '#1f2937' : '#e5e7eb';
        ctx.fill();

        if (avatarState?.status === 'loaded') {
          ctx.save();
          ctx.beginPath();
          ctx.arc(xCenter, yCenter, radius - 1, 0, Math.PI * 2);
          ctx.closePath();
          ctx.clip();
          ctx.drawImage(avatarState.img, xCenter - radius, yCenter - radius, avatarSize, avatarSize);
          ctx.restore();
        } else {
          const initial = String(p?.nombre || '?').trim().charAt(0).toUpperCase() || '?';
          ctx.font = chartWidth < 420 ? '700 8px Segoe UI, sans-serif' : '700 10px Segoe UI, sans-serif';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillStyle = document.documentElement.classList.contains('dark') ? '#f3f4f6' : '#374151';
          ctx.fillText(initial, xCenter, yCenter);
        }

        ctx.beginPath();
        ctx.arc(xCenter, yCenter, radius, 0, Math.PI * 2);
        ctx.closePath();
        ctx.lineWidth = 1.5;
        ctx.strokeStyle = document.documentElement.classList.contains('dark') ? '#4b5563' : '#d1d5db';
        ctx.stroke();
        ctx.restore();
      });
    },
    afterEvent: (chart, args) => {
      const event = args?.event;
      if (!event) {
        return;
      }

      const hitIndex = getAvatarHitIndex(chart, event.x, event.y);

      if (event.type === 'mousemove' || event.type === 'mouseout') {
        const canvas = chart?.canvas;
        if (canvas) {
          canvas.style.cursor = hitIndex >= 0 ? 'pointer' : 'default';
        }
      }

      if ((event.type === 'click' || event.type === 'mouseup') && hitIndex >= 0) {
        scrollToParticipantCard(hitIndex);
      }
    },
  };

  // Cerrar al pulsar Escape
  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onClose]);

  const chartData = {
    labels: participantes.map(() => ''),
    datasets: [
      {
        label: 'Preguntas acertadas',
        data: participantes.map(p => Number(p.preguntas_acertadas) || 0),
        backgroundColor: rankedParticipants.map(({ rank }) =>
          rank >= 1 && rank <= BAR_COLORS.length ? BAR_COLORS[rank - 1] : DEFAULT_BAR_COLOR
        ),
        borderColor: rankedParticipants.map(({ rank }) =>
          rank >= 1 && rank <= BORDER_COLORS.length ? BORDER_COLORS[rank - 1] : DEFAULT_BORDER
        ),
        borderWidth: 2,
        borderRadius: 6,
      },
      {
        label: 'Comodines restantes',
        data: participantes.map(p => Number(p.comodines_restantes) || 0),
        backgroundColor: 'rgba(167, 243, 208, 0.7)',
        borderColor: 'rgba(52, 211, 153, 1)',
        borderWidth: 2,
        borderRadius: 6,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    onClick: (_event, elements) => {
      const idx = elements?.[0]?.index;
      if (idx !== undefined) {
        scrollToParticipantCard(idx);
      }
    },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          title: (items) => {
            const idx = items?.[0]?.dataIndex;
            return idx !== undefined ? (participantes[idx]?.nombre || '') : '';
          },
          label: (ctx) => `${ctx.dataset.label}: ${ctx.parsed.y}`,
        },
      },
    },
    layout: {
      padding: {
        bottom: isMobileViewport ? 26 : 34,
      },
    },
    scales: {
      x: {
        ticks: {
          display: false,
        },
        grid: { display: false },
        border: { display: false },
      },
      y: {
        alignToPixels: true,
        min: 0,
        max: FIXED_Y_MAX,
        display: true,
        ticks: {
          display: false,
          stepSize: FIXED_Y_STEP,
        },
        grid: {
          drawTicks: false,
          drawBorder: false,
          color: document.documentElement.classList.contains('dark')
            ? 'rgba(148, 163, 184, 0.16)'
            : 'rgba(100, 116, 139, 0.18)',
          lineWidth: 1,
        },
      },
    },
  };

  const axisChartData = {
    labels: ['escala'],
    datasets: [
      {
        data: [0],
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: 'rgba(0, 0, 0, 0)',
        borderWidth: 0,
      },
    ],
  };

  const axisChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    layout: {
      padding: {
        bottom: isMobileViewport ? 26 : 34,
      },
    },
    scales: {
      x: {
        ticks: {
          display: false,
        },
        grid: { display: false },
        border: { display: false },
      },
      y: {
        alignToPixels: true,
        position: 'right',
        min: 0,
        max: FIXED_Y_MAX,
        ticks: {
          color: document.documentElement.classList.contains('dark') ? '#e2e8f0' : '#1a202c',
          stepSize: FIXED_Y_STEP,
          font: { size: isMobileViewport ? 12 : 11, weight: '700' },
          padding: isMobileViewport ? 2 : 3,
          mirror: false,
          crossAlign: 'far',
          callback: (value) => String(value),
        },
        grid: {
          display: false,
        },
      },
    },
  };

  return (
    <div
      ref={backdropRef}
      className="fixed inset-x-0 top-16 bottom-28 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-3 sm:top-20 sm:bottom-24 sm:p-4"
      onClick={(e) => { if (e.target === backdropRef.current) onClose(); }}
    >
      <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl w-full max-w-2xl max-h-full flex flex-col overflow-hidden">
        {/* Header modal */}
        <div className="flex items-center justify-between px-4 sm:px-6 py-4 border-b dark:border-gray-700 gap-3">
          <h2 className="text-lg sm:text-xl font-extrabold dark:text-white flex items-center gap-2">
            Ranking completo
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-700 dark:hover:text-white transition-colors rounded-md p-1 hover:bg-gray-100 dark:hover:bg-gray-700"
            aria-label="Cerrar"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Contenido: gráfico fijo + lista con scroll */}
        <div className="flex-1 min-h-0 px-4 sm:px-6 py-4 flex flex-col gap-6">
          {/* Gráfico fijo */}
          {participantes.length > 0 && (
            <div className="space-y-2 shrink-0">
              <div className="flex items-center justify-center gap-3 sm:gap-5 text-[11px] sm:text-xs font-semibold">
                <div className="flex items-center gap-2 whitespace-nowrap text-gray-700 dark:text-gray-200">
                  <span className="inline-block w-3 h-3 rounded-sm" style={{ backgroundColor: BAR_COLORS[0] }} />
                  Preguntas acertadas
                </div>
                <div className="flex items-center gap-2 whitespace-nowrap text-gray-700 dark:text-gray-200">
                  <span className="inline-block w-3 h-3 rounded-sm" style={{ backgroundColor: 'rgba(167, 243, 208, 0.7)' }} />
                  Comodines restantes
                </div>
              </div>

              <div className="flex items-stretch gap-1 sm:gap-2">
                <div className="w-14 sm:w-12 shrink-0">
                  <div style={{ height: chartHeight }}>
                    <Bar data={axisChartData} options={axisChartOptions} />
                  </div>
                </div>

                <div className="ranking-horizontal-scroll min-w-0 flex-1 overflow-x-auto">
                  <div style={{ width: chartMinWidth, height: chartHeight }}>
                    <Bar data={chartData} options={chartOptions} plugins={[avatarTickPlugin]} />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Lista completa con scroll independiente */}
          <div className="min-h-0 flex-1 overflow-y-auto pr-1">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 sm:gap-3">
            {rankedParticipants.map(({ participant: p, rank, index: idx }) => (
              <div
                key={getParticipantKey(p, idx)}
                ref={(el) => {
                  const key = getParticipantKey(p, idx);
                  if (el) {
                    cardRefs.current[key] = el;
                  } else {
                    delete cardRefs.current[key];
                  }
                }}
                className={`flex flex-col items-center gap-2 p-2 sm:p-3 rounded-xl border transition-colors min-h-[150px] ${
                  rank === 1
                    ? 'bg-yellow-50 dark:bg-yellow-900/20 border-yellow-200 dark:border-yellow-700'
                    : rank === 2
                    ? 'bg-gray-50 dark:bg-gray-800/50 border-gray-200 dark:border-gray-600'
                    : rank === 3
                    ? 'bg-amber-50 dark:bg-amber-900/20 border-amber-200 dark:border-amber-700'
                    : 'bg-white dark:bg-gray-800 border-gray-100 dark:border-gray-700'
                }`}
              >
                {/* Posición */}
                <div className="w-full text-center">
                  <span className="font-bold text-xs text-gray-500 dark:text-gray-400">#{rank}</span>
                </div>

                {/* Avatar */}
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full overflow-hidden bg-gray-200 dark:bg-gray-700 border border-gray-300 dark:border-gray-600 mx-auto">
                  {p.imagen ? (
                    <img
                      src={buildImageUrl(p.imagen)}
                      alt={p.nombre}
                      className="w-full h-full object-cover"
                      onError={e => { e.target.onerror = null; e.target.src = '/media/images/default-fallback.png'; }}
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <svg className="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/>
                      </svg>
                    </div>
                  )}
                </div>

                {/* Nombre + RRSS */}
                <div className="w-full text-center">
                  {p.rrss ? (
                    <a
                      href={p.rrss}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="font-semibold text-xs sm:text-sm text-gray-800 dark:text-white hover:text-blue-600 dark:hover:text-blue-400 hover:underline inline-flex items-center gap-1 max-w-full"
                      title={`Ver en ${getSocialLabel(p.rrss)}`}
                    >
                      <span className="truncate max-w-[96px] sm:max-w-[120px]">{p.nombre}</span>
                      <span className="text-gray-400 dark:text-gray-500">{getSocialIcon(p.rrss)}</span>
                    </a>
                  ) : (
                    <span className="font-semibold text-xs sm:text-sm text-gray-800 dark:text-white truncate inline-block max-w-[96px] sm:max-w-[120px]">{p.nombre}</span>
                  )}
                </div>

                {/* Stats */}
                <div className="w-full flex items-center justify-center gap-2 text-center">
                  <div className="min-w-0">
                    <div className="text-xs sm:text-sm font-extrabold text-gray-800 dark:text-white leading-none">
                      {p.preguntas_acertadas}
                    </div>
                    <div className="text-[9px] text-gray-400 leading-none">aciertos</div>
                  </div>
                  <div className="min-w-0">
                    <div className="text-xs sm:text-sm font-bold text-emerald-600 dark:text-emerald-400 leading-none">
                      {p.comodines_restantes}
                    </div>
                    <div className="text-[9px] text-gray-400 leading-none">comodines</div>
                  </div>
                </div>
              </div>
            ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
